import { render, staticRenderFns } from "./regleur.vue?vue&type=template&id=4816414e&scoped=true"
import script from "./regleur.vue?vue&type=script&lang=js"
export * from "./regleur.vue?vue&type=script&lang=js"
import style0 from "./regleur.vue?vue&type=style&index=0&id=4816414e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4816414e",
  null
  
)

export default component.exports